import { TFunction } from 'i18next'
import * as yup from 'yup'

export const campaignSchema = (t: TFunction<'translation', undefined>) =>
    yup.object({
        mailer_campaign_name: yup
            .string()
            .required(t('mailerCampaign:campaign_name_required'))
            .default(''),
        mailer_campaign_description: yup.string().default(''),
        mailer_campaign_source_type: yup
            .string()
            .oneOf(['internal', 'external'] as const)
            .required()
            .default('internal'),
        template_subject: yup.string().default(''),
        template_content: yup
            .string()
            .required(t('mailerCampaign:template_content_required'))
            .default(''),
        test_email: yup.string().email(t('invalid-email')).default(''),
        smtp_enabled: yup.boolean().default(false),
        sender_enabled: yup.boolean().default(false),
        mailer_campaign_internal_mode: yup
            .string()
            .oneOf(['preset', 'filters'] as const)
            .default('filters'),
        mailer_campaign_internal_type: yup
            .string()
            .oneOf(['customers', 'services'] as const)
            .default('customers'),
        mailer_campaign_filters: yup
            .object({
                customer_status: yup
                    .array()
                    .of(yup.string().required())
                    .default([]),
                customer_industry: yup
                    .array()
                    .of(yup.string().required())
                    .default([]),
                product_group_name: yup
                    .array()
                    .of(yup.string().required())
                    .default([]),
                service_status: yup
                    .array()
                    .of(yup.string().required())
                    .default([]),
                service_interestings: yup
                    .array()
                    .of(yup.string().required())
                    .default([]),
                customer_sale_followers: yup
                    .array()
                    .of(yup.number().required())
                    .default([]),
            })
            .default({
                customer_status: [],
                customer_industry: [],
                product_group_name: [],
                service_status: [],
                service_interestings: [],
                customer_sale_followers: [],
            }),
        metadata: yup
            .object({
                mailer: yup
                    .object({
                        address: yup.string().default(''),
                        user_name: yup.string().default(''),
                        password: yup.string().default(''),
                    })
                    .default({
                        address: '',
                        user_name: '',
                        password: '',
                    }),
                sender: yup
                    .object({
                        name: yup.string().default(''),
                        gender: yup.string().default(''),
                        phone: yup.string().default(''),
                        position: yup.string().default(''),
                    })
                    .default({
                        name: '',
                        gender: '',
                        phone: '',
                        position: '',
                    }),
            })
            .default({
                mailer: { address: '', user_name: '', password: '' },
                sender: { name: '', gender: '', phone: '', position: '' },
            }),
    })
